"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManager_1 = require("../ApiManager");
var ApiConfig_1 = require("../config/ApiConfig");
/**
 * App과 연동되는 API 리스트
 */
var ApiGlobal = /** @class */ (function (_super) {
    __extends(ApiGlobal, _super);
    function ApiGlobal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.GLOBAL_USER = "/api/v2/global/user";
        _this.globalUser = function (token) {
            return ApiConfig_1.Axios.Client({
                header: { token: token },
                method: "post",
                url: _this.GLOBAL_USER,
            });
        };
        return _this;
    }
    ApiGlobal.getInstance = function (initValue) {
        if (!ApiGlobal.classInstance) {
            this.classInstance = new ApiGlobal(initValue);
        }
        return this.classInstance;
    };
    return ApiGlobal;
}(ApiManager_1.ApiManager));
exports.default = ApiGlobal;
